import { ReactElement } from 'react'
import { Button, Text } from '@raskrask-dk/rr-components'
import CompanyCardPage from '../../companycard'
import { useTranslation } from 'react-i18next'
import { PropsFrequencyTemplate } from './props'
import { StyledPickButtons } from '../../companycard/styles'
import { CompanyLeadFrequency } from '@raskrask-dk/raskrask-utils'

const FrequencyTemplate = ({
    frequency,
    currentStep,
    onClickFrequency,
    helpers,
}: PropsFrequencyTemplate): ReactElement => {
    const { t } = useTranslation()

    const frequencyOptions: {
        label: string
        value: CompanyLeadFrequency
    }[] = [
        {
            label: t('companylead.frequency.options.weekly'),
            value: 'Ugentlig',
        },
        {
            label: t('companylead.frequency.options.secondweek'),
            value: 'Hver 2. uge',
        },
        {
            label: t('companylead.frequency.options.monthly'),
            value: 'Månedligt',
        },
        {
            label: t('companylead.frequency.options.other'),
            value: 'Andet',
        },
    ]

    const choosenText = frequencyOptions.find((freq) => freq.value === frequency)?.label ?? ''

    return (
        <CompanyCardPage
            choosenText={[choosenText]}
            dataCy="accordion-frequency"
            onClickNext={helpers.goToNextStep}
            open={currentStep === 1}
            setOpen={() => helpers.setStep(currentStep === 1 ? 7 : 1)}
            title={t('companylead.frequency.header')}
        >
            <Text>{t('companylead.frequency.text')}</Text>
            <StyledPickButtons
                css={{
                    '@mobile': {
                        gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))',
                    },
                }}
            >
                {frequencyOptions &&
                    frequencyOptions.map((option, key) => (
                        <Button
                            active={option.value === frequency}
                            data-cy={`frequency_${key + 1}`}
                            key={option.value}
                            onClick={() => onClickFrequency(option.value)}
                            size="large"
                            variant="option"
                        >
                            {option.label}
                        </Button>
                    ))}
            </StyledPickButtons>
        </CompanyCardPage>
    )
}

export default FrequencyTemplate
